export default class InterfaceTransitions {
    constructor(fc) {
        this.fc = fc;
    }

    init(main_selector = ".perspective") {
        this.main = $(main_selector);
        this.current = 0;
        this.isAnimating = false;
        this.endCurrPage = false;
        this.endNextPage = false;
        this._toFastIndex = -1;
    }

    getCurrent() {
        return this.current;
    }

    setCurrent(index) {
        this.current = index;
    }

    goToPage(callback, index, spread_id, prev_spread_id, scope = this.fc) {
        let hasIssueData = Object.keys(this.fc.dataHelper._issue_data).length > 0;
        var inClass, outClass;
        if (index === this.current) {
            return callback.apply(scope);
        }

        if (this.isAnimating) {
            this._toFastIndex = spread_id;
            this.current = index;
            this.resetPageFast(callback, scope, spread_id);
            return false;
        }

        let subTransition = 0;
        let newMainspreadId;
        if (hasIssueData) {
            newMainspreadId = this.fc.dataHelper.findMainSpreadIdOfSubSpread(this.fc.getCurrentIssueId(), spread_id);
            subTransition = this.fc.dataHelper._issue_data?.[this.fc.getCurrentIssueId()]?.find(
                (spread) => spread.id === newMainspreadId,
            )?.transition;
        }

        this.normalNext = {
            inClass: `pt-page-moveFromRight inSpread`,
            outClass: `pt-page-moveToLeft outSpread current-spread`,
        };

        this.normalPrev = {
            inClass: `pt-page-moveFromLeft inSpread`,
            outClass: `pt-page-moveToRight outSpread current-spread`,
        };

        switch (subTransition) {
            default:
            case 0:
                this.subNext = {
                    inClass: `pt-page-moveFromUp inSpread`,
                    outClass: `pt-page-moveToDown outSpread current-spread`,
                };

                this.subPrev = {
                    inClass: `pt-page-moveFromDown inSpread`,
                    outClass: `pt-page-moveToUp outSpread current-spread`,
                };
                break;
            case 1:
                this.subNext = {
                    inClass: `pt-page-moveFromUp inSpread`,
                    outClass: `pt-page-moveToDownEasing outSpread current-spread`,
                };

                this.subPrev = {
                    inClass: `pt-page-moveFromDown inSpread`,
                    outClass: `pt-page-moveToUpEasing outSpread current-spread`,
                };
                break;
            case 2:
                this.subNext = {
                    inClass: `pt-page-crossfadeIn inSpread`,
                    outClass: `pt-page-crossfadeOut outSpread current-spread`,
                };

                this.subPrev = {
                    inClass: `pt-page-crossfadeIn inSpread`,
                    outClass: `pt-page-crossfadeOut outSpread current-spread`,
                };
                break;
        }

        this._toFastIndex = -1;
        this.isAnimating = [spread_id, prev_spread_id];

        const isCurrentMain = hasIssueData
            ? this.fc.dataHelper.isMainSpread(this.fc.getCurrentIssueId(), spread_id)
            : true;
        const isPrevMain = hasIssueData
            ? this.fc.dataHelper.isMainSpread(this.fc.getCurrentIssueId(), prev_spread_id)
            : true;

        // main to sub
        if (isPrevMain && !isCurrentMain) {
            inClass = this.subNext.inClass;
            outClass = this.subNext.outClass;
            this.fc.setClickNavigation(false);
        } else if (!isPrevMain && isCurrentMain) {
            // sub to main
            inClass = this.subPrev.inClass;
            outClass = this.subPrev.outClass;
        } else if (isPrevMain && isCurrentMain) {
            // main to main
            if (index > this.current) {
                inClass = this.normalNext.inClass;
                outClass = this.normalNext.outClass;
            } else {
                inClass = this.normalPrev.inClass;
                outClass = this.normalPrev.outClass;
            }
        } else if (!isPrevMain && !isCurrentMain) {
            // sub to sub
            if (
                newMainspreadId ===
                this.fc.dataHelper.findMainSpreadIdOfSubSpread(this.fc.getCurrentIssueId(), prev_spread_id)
            ) {
                inClass = this.subNext.inClass;
                outClass = this.subNext.outClass;
                this.fc.setClickNavigation(false);
            } else {
                inClass = this.normalPrev.inClass;
                outClass = this.normalPrev.outClass;
                this.fc.setClickNavigation(false);
            }
        }

        let articles = this.main.children();
        var $currPage = articles.filter(`#maglr-article-${prev_spread_id}`);
        var $nextPage = articles.filter(`#maglr-article-${spread_id}`);
        this.$currPage = $currPage;
        this.$nextPage = $nextPage;

        this.current = index;

        $currPage
            .data("outClass", outClass)
            .on("animationend", () => {
                $currPage.off("animationend");
                this.endCurrPage = true;
                $currPage.addClass("preloadedSpread").attr("aria-hidden", "true");
                if (this.endNextPage) {
                    this.onEndAnimation($currPage, $nextPage, callback, scope);
                }
            })
            .addClass(outClass);

        $nextPage
            .data("inClass", inClass)
            .on("animationend", () => {
                $nextPage.off("animationend");
                this.endNextPage = true;
                if (this.endCurrPage) {
                    this.onEndAnimation($currPage, $nextPage, callback, scope);
                }
            })
            .removeClass("preloadedSpread")
            .removeAttr("aria-hidden")
            .addClass(inClass);
    }

    onEndAnimation($outpage, $inpage, callback, scope) {
        this.endCurrPage = false;
        this.endNextPage = false;
        this.isAnimating = false;
        $inpage.removeClass("preloadedSpread").removeAttr("aria-hidden");
        this.resetPage($outpage, $inpage);
        callback.apply(scope, [$inpage.find("[data-spread-id]").data("spread-id")]);
    }

    //TMP fix reset if we have fast navigation
    resetPageFast(callback, scope, spread_id) {
        let articles = this.main.children();

        //if we navigate fast back to spread that is in transition.
        if (this.isAnimating?.indexOf(spread_id) > -1) {
            this.onEndAnimation(this.$currPage, this.$nextPage, callback, scope);
        } else {
            //always remove the preloadedSpread and call
            articles.filter(`#maglr-article-${spread_id}`).removeClass("preloadedSpread").removeAttr("aria-hidden");
            callback.apply(scope, [spread_id]);
        }
    }

    resetPage($outpage, $inpage) {
        $outpage.removeClass($outpage.data("outClass"));

        $inpage.removeClass($inpage.data("inClass"));

        if (this._toFastIndex > -1) {
            // _toFastIndex is a spread id, only usable for the DOM lookup; this.current is an
            // index and was already set by the fast path in goToPage, so don't assign it here
            $inpage = $("[data-article-id=" + this._toFastIndex + "]");
            $inpage.addClass("current-spread");
            $("main").children(":not(.current-spread,.preloadedSpread)").addClass("preloadedSpread");
            this._toFastIndex = -1;
        }

        $inpage.addClass("current-spread");
    }
}
